export default __webpack_public_path__ + "static/lpr-video.hevc-34c953c52b064c84b99aeba0ac7e045f.mp4";